import GuideContent from "../components/GuideContent/GuideContent";
import Layout from "../components/Layout/Layout";

const Guide = () => {
    return(
    <Layout>
        <GuideContent />
    </Layout>
)
}

export default Guide;